export default __webpack_public_path__ + "static/media/cal_bg3.0c26e5cf.jpg";